<button
  type="button"
  class="app-button app-button--{{ variant() }}"
  [disabled]="disabled()"
  (click)="clicked.emit()"
>
  {{ label() }}
</button>
